import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleTrimEditor = ({
  tradeId,
  initialTrim,
}: {
  tradeId: Trade['id'];
  initialTrim: string;
}) => {
  const [trim, setTrim] = useState(initialTrim);

  const updateTrimMutation = useMutation({
    onMutate: async ({ trim }: { trim: string }) => {
      tradesStore.updateTrade(tradeId, {
        trim: trim,
      });
    },
    mutationFn: async ({ trim }: { trim: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/trim`,
        // /api/trades/:trade_id/trim
        {
          trim,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating trim', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleTrimChange = useCallback(
    debounce((newTrim: string) => {
      updateTrimMutation.mutate({ trim: newTrim });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (trim === initialTrim) return;

    handleTrimChange(trim);
  }, [trim]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setTrim(e.target.value);
  }, []);

  useEffect(() => {
    setTrim(initialTrim);
  }, [initialTrim]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Trim</div>
      </div>
      <InlineTextInput
        value={trim}
        onChange={onChange}
        placeholder="Enter trim"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleTrimEditor;
